import styled from "styled-components";

export const Container = styled.div`
	.MuiInputBase-root {
		border: 1px solid ${(props) => props.theme.grayDark};
	}
`;
